import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap/lib';
import './Switch.scss';

function Switch({ formData, name, label, onChange, disabled }) {
  const enabled = get(formData, name);
  return (
    <FormGroup>
      <div
        className={classNames(
          'widget-toggle-input',
          disabled ? 'widget-toggle-input-disabled' : '',
        )}
      >
        <ControlLabel>{label}</ControlLabel>
        <label className="switch-input">
          <FormControl
            name={name}
            type="checkbox"
            checked={enabled}
            onChange={() => {
              onChange({
                target: { name, value: !enabled },
              });
            }}
            disabled={disabled}
          />
          <span className="slider" />
        </label>
        <ControlLabel>{enabled ? 'On' : 'Off'}</ControlLabel>
      </div>
    </FormGroup>
  );
}

Switch.propTypes = {
  formData: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Switch;
